import { Pipe, PipeTransform } from '@angular/core';

/**
 * A pipe which transforms a string identifier for a bookmaker, into a URL string for the image file of that
 * bookmaker's "alternative" square (or near-square) icon. As opposed to the [`BookIconPipe`](./book-icon.pipe.ts),
 * the image returned here is specifically designed to appear against the corresponding bookmaker's brand background
 * colour (i.e. the result of passing the same identifier to the [`BookBackgroundColourPipe`](./book-background-colour.pipe.ts)).
 * For some bookmakers, the result of both pipes is the same image.
 */
@Pipe({
  name: 'bookIconAlt'
})
export class BookIconAltPipe implements PipeTransform {

  /**
   * A pipe which transforms a string identifier for a bookmaker, into a URL string for the image file of that
   * bookmaker's "alternative" square (or near-square) icon. As opposed to the [`BookIconPipe`](./book-icon.pipe.ts),
   * the image returned here is specifically designed to appear against the corresponding bookmaker's brand background
   * colour (i.e. the result of passing the same identifier to the [`BookBackgroundColourPipe`](./book-background-colour.pipe.ts)).
   * For some bookmakers, the result of both pipes is the same image.
   * @param bookName the identifier code for the bookmaker object, as returned by the sport data APIs
   * @returns a URL to the alternative icon image for the corresponding bookmaker, or an empty string if the identifier
   * does not match one of the recognised identifiers
   */
  transform(bookName: string): string {
    switch (bookName?.toLowerCase()) {
      case "betstreet":
        return "https://content-blocks-node.azurewebsites.net/static/assets/betstreet-icon-white.png";
      case "fanduel":
        return "https://content-blocks-node.azurewebsites.net/static/assets/fanduel-icon-white.svg";
      case "sugarhouse":
        return "https://content-blocks-node.azurewebsites.net/static/assets/sugarhouse-icon-white.png";
      case "pointsbet":
      case "pointsbet_au":
        return "https://content-blocks-node.azurewebsites.net/static/assets/pointsbet-icon-white.png";
      case "william_hill":
        return "https://content-blocks-node.azurewebsites.net/static/assets/william-hill-icon-white.png";
      case "draftkings":
        return "https://content-blocks-node.azurewebsites.net/static/assets/draftkings-icon-white.svg";
      case "wynn":
        return "https://cdn.ciphersports.io/images/bookmaker-images/wynnbet-icon.png";
      case "betmgm":
        return "https://content-blocks-node.azurewebsites.net/static/assets/betmgm-icon-white.png";
      case "bet_rivers_in":
      case "bet_rivers_va":
      case "bet_rivers_co":
        return "https://content-blocks-node.azurewebsites.net/static/assets/bet-rivers-icon-white.svg";
      case "bet365":
      case "bet_365":
        return "https://content-blocks-node.azurewebsites.net/static/assets/bet365-icon-white.svg";
      case "betway":
        return "https://content-blocks-node.azurewebsites.net/static/assets/betway-icon-white.png";
      case "unibet":
        return "https://content-blocks-node.azurewebsites.net/static/assets/unibet-icon-white.png";
      case "tipico":
        return "https://content-blocks-node.azurewebsites.net/static/assets/tipico-icon-white.png";
      case "twinspires":
        return "https://content-blocks-node.azurewebsites.net/static/assets/twinspires-icon-white.png";
      case "bluebet":
        return "https://content-blocks-node.azurewebsites.net/static/assets/bluebet-icon-white.png";
      case "topsport":
        return "https://content-blocks-node.azurewebsites.net/static/assets/topsport-icon.png";
      case "betfair":
        return "https://content-blocks-node.azurewebsites.net/static/assets/betfair-icon.svg";
      default:
        return "initial"
    }
  }

}
